import { registerComponent } from '@gig/magic-common';
import PurchasesTransactionsComponent from './purchases.vue.js';

var PurchaseTransactions = registerComponent(PurchasesTransactionsComponent);

export { PurchaseTransactions };
